/**
 * @generated SignedSource<<b4031f95d5019fc6f71837e1e41d5efa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateHydrantFamilyInput = {
  name: string;
  manufacturerId: string;
  clientMutationId?: string | null;
};
export type createPageCreateHydrantFamilyMutation$variables = {
  input: CreateHydrantFamilyInput;
};
export type createPageCreateHydrantFamilyMutationVariables = createPageCreateHydrantFamilyMutation$variables;
export type createPageCreateHydrantFamilyMutation$data = {
  readonly createHydrantFamily: {
    readonly hydrantFamily: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateHydrantFamilyMutationResponse = createPageCreateHydrantFamilyMutation$data;
export type createPageCreateHydrantFamilyMutation = {
  variables: createPageCreateHydrantFamilyMutationVariables;
  response: createPageCreateHydrantFamilyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateHydrantFamilyPayload",
    "kind": "LinkedField",
    "name": "createHydrantFamily",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantFamily",
        "kind": "LinkedField",
        "name": "hydrantFamily",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateHydrantFamilyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateHydrantFamilyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ddd64ef7a849e76633dcba36844cdc25",
    "id": null,
    "metadata": {},
    "name": "createPageCreateHydrantFamilyMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateHydrantFamilyMutation(\n  $input: CreateHydrantFamilyInput!\n) {\n  createHydrantFamily(input: $input) {\n    hydrantFamily {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38754ef61335e82cfd96b8186e1d9f6d";

export default node;
